import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';

export class DocumentService {
  public static async approveDocument(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post('/aprove-documents', payload, config);

    return data;
  }

  public static async reproveDocument(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post('/reprove-documents', payload, config);

    return data;
  }

  public static async moreInfoDocument(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post('/request-more-info', payload, config);

    return data;
  }

  public static async resendDocument(api: AxiosInstance, payload: any, config: ServiceBaseConfig): Promise<any> {
    const { data } = await api.post('/resend-document', payload, config);

    return data;
  }
}
